import { GamesUIComponentFilterEnum, GamesUIComponentFilterType, ItemWithTranslation } from 'types/swagger';
import { Tooltip, TooltipPosition } from 'components/tooltip';

import { ConditionalCheckbox } from '../conditionalCheckbox';
import { isTruthy } from 'utility/functions';
import styles from './SlotArchiveFiltersModalRow.module.scss';
import { useMemo } from 'react';
import { useTranslation } from 'hooks/useLingUI';

export type SlotArchiveFiltersModalRowProps = ItemWithTranslation<{ values: string[]; tooltipLabel?: string }> & {
  id?: string;
  className?: string;
  typeOfItem: GamesUIComponentFilterType;
  tooltipContent?: string;
  selectedValues?: string[];
  selectedFilterValues?: { [type: string]: string[] };
  handleFilterChange: Function;
};

export const SlotArchiveFiltersModalRow = ({
  id,
  values,
  typeOfItem,
  valuesTrKey,
  tooltipLabel,
  tooltipLabelTrKey,
  tooltipContent,
  selectedValues,
  handleFilterChange,
  selectedFilterValues,
}: SlotArchiveFiltersModalRowProps) => {
  const { t } = useTranslation();
  let res = useMemo(() => {
    switch (typeOfItem) {
      case GamesUIComponentFilterEnum.Toggle:
        return 'toggleFilter';
      case GamesUIComponentFilterEnum.Simple:
        return 'simpleFilter';
      // case GamesUIComponentFilterEnum.Chip: return 'filter';
      default:
        return 'filter';
    }
  }, [typeOfItem]);

  const options = useMemo(() => {
    return values?.map((value, idx) => {
      let label = '';
      let labelTrKey: string | undefined;
      let keep = isTruthy(`${value ?? ''}`.length);
      let checked = false;
      if (keep) {
        label = value;
        const ck = isTruthy(id?.length) && (Reflect.get(selectedFilterValues ?? {}, id!) ?? []).includes(value);
        checked = (ck || selectedValues?.includes(value)) ?? false;
        labelTrKey = valuesTrKey?.[idx];
      }
      return {
        keep,
        value,
        label,
        checked,
        labelTrKey,
      };
    });
  }, [id, values, valuesTrKey, selectedValues, selectedFilterValues]);

  return (
    <div key={id} className={styles[res]}>
      <div className={styles.tooltipContainer}>
        <p className={styles.tooltipLabel}>{t(tooltipLabelTrKey, tooltipLabel)}</p>
        {tooltipContent && <Tooltip content={tooltipContent} position={TooltipPosition.RIGHT}></Tooltip>}
      </div>
      <div className={styles.filterValues}>
        {options
          .filter((x) => isTruthy(x.keep))
          .map(({ value, label, checked, labelTrKey }) => (
            <ConditionalCheckbox
              key={value}
              type={typeOfItem}
              value={value}
              label={label}
              labelTrKey={labelTrKey}
              checked={checked}
              classNameChip={styles.checkbox}
              handleFilterChange={(el: HTMLInputElement) => {
                handleFilterChange(id, el);
              }}
            />
          ))}
      </div>
    </div>
  );
};
